import { Document } from "../../../domain/document";
import { EditingDocument } from "../editor";
import { EditingDocumentMerger } from "../editor/helpers";


export class DocumentMerger extends EditingDocumentMerger {
  constructor(source: EditingDocument | Document) {
    super(
      (source instanceof EditingDocument)
        ? source
        : new EditingDocument(source)
    );
  }

  get sourceAsDocument(): Document {
    return this.source.source;
  }
}
